export enum EntityType {
    FORM = 'F', // blue
    REPORT = 'R', // red
    PROCEDURE = 'P', // green
    DOCUMENT = 'H', // purple
    WIZARD = 'W', // green
    GANTT = 'G', // green
    MENU = 'M',
    DASHBOARD = 'D', // green
    BIREPORT = 'O' // green
}

export const EntityClasses = {
    [EntityType.FORM]: 'form-entity',
    [EntityType.REPORT]: 'rep-entity',
    [EntityType.PROCEDURE]: 'proc-entity',
    [EntityType.DOCUMENT]: 'menu-entity',
    [EntityType.WIZARD]: 'wiz-entity'
};
